import { DSLinkButton } from "@components/design-system/molecules";

import ScribblesQuestion from "../../../assets/imgs/scribbles-question.png";
export default function SSOError() {
  const params = new URLSearchParams(window.location.search);
  const message =
    params.get("message") || "Something went wrong with your SSO";

  return (
    <div className="flex grow items-center justify-center flex-col gap-4 ">
      <img className="max-h-[300px]" src={ScribblesQuestion} />
      <div className="text-xl text-danger">{message}</div>
      <DSLinkButton
        href="/auth/login"
        dataTestId="sso-error-back-to-login"
      >
        Back to Login
      </DSLinkButton>
    </div>
  );
}
